export default {
  sRole: {
      banhangtragop_cauhinhsanpham: "banhangtragop_cauhinhsanpham",
      banhangtragop: "banhangtragop",
      banhangtragop_danhsach: "banhangtragop_danhsach",
      banhangtragop_themmoi: "banhangtragop_themmoi",
      banhangtragop_sua: "banhangtragop_sua",
      banhangtragop_xoa: "banhangtragop_xoa",
      banhangtragop_thanhtoan: "banhangtragop_thanhtoan",
      banhangtragop_tattoan: "banhangtragop_tattoan",
      banhangtragop_giahan: "banhangtragop_giahan",
      banhangtragop_nhantin: "banhangtragop_nhantin",
      banhangtragop_guiemail: "banhangtragop_guiemail",
      banhangtragop_thongtinchitiethopdong:
        "banhangtragop_thongtinchitiethopdong",
      banhangtragop_thongtinchitietkhachhang:
        "banhangtragop_thongtinchitietkhachhang",
      banhangtragop_xuatexceldanhsach: "banhangtragop_xuatexceldanhsach",
      banhangtragop_doitinhtranghopdong: "banhangtragop_doitinhtranghopdong",
      banhangtragop_sudungchoduyet: "banhangtragop_sudungchoduyet",
      banhangtragop_thaydoitienlai: "banhangtragop_thaydoitienlai",
      banhangtragop_suatientattoan: "banhangtragop_suatientattoan",
      banhangtragop_inhopdong: "banhangtragop_inhopdong",

      // Loại phiếu thu/chi
      loaiphieuthuchi: "loaiphieuthuchi",
      cauhinhphieuthuchi_themmoi: "cauhinhphieuthuchi_themmoi",
      cauhinhphieuthuchi_sua: "cauhinhphieuthuchi_sua",
      cauhinhphieuthuchi_xoa: "cauhinhphieuthuchi_xoa",
      cauhinhphieuthuchi_khoa: "cauhinhphieuthuchi_khoa",
      cauhinhphieuthuchi_mo: "cauhinhphieuthuchi_mo",

      // Quản lý mẫu hợp đồng
      quanlymauhopdong: "quanlymauhopdong",
      quanlymauhopdong_themmoi: "quanlymauhopdong_themmoimauhopdong",
      quanlymauhopdong_sua: "quanlymauhopdong_suamauhopdong",
      quanlymauhopdong_xem: "quanlymauhopdong_xemmauhopdong",
      quanlymauhopdong_xoa: "quanlymauhopdong_xoamauhopdong",

      // Kiểm kê Quỹ
      kiemkequy: "kiemkequy",
      kiemkequy_themmoi: "kiemkequy_themmoi",
      kiemkequy_sua: "kiemkequy_sua",
      kiemkequy_chitiet: "kiemkequy_chitiet",

      // Cấu hình tính lãi
      cauhinhtinhlai: "cauhinhtinhlai",

      //Cấu hình hệ thống
      cauhinhhethong: "cauhinhhethong",

      //Thống kê thu
      thu: "thu",
      thu_inphieuthu: "thu_inphieuthu",
      thu_chitiethopdongvay: "thu_chitiethopdongvay",
      thu_chitietkhachhang: "thu_chitietkhachhang",

      //Thống kê chi
      chi: "chi",
      chi_inphieuchi: "chi_inphieuchi",
      chi_chitiethopdong: "chi_chitiethopdong",
      chi_chitietkhachhang: "chi_chitietkhachhang",

      //Thống kê thu dự kiến
      thudukien: "thudukien",

      // Quản lý công việc
      quanlycongviec: "quanlycongviec",
      quanlycongviec_themcongviec: "quanlycongviec_themcongviec",
      quanlycongviec_suacongviec: "quanlycongviec_suacongviec",
      quanlycongviec_xoacongviec: "quanlycongviec_xoacongviec",
      quanlycongviec_giahan: "quanlycongviec_giahan",
      quanlycongviec_giaochonguoikhac: "quanlycongviec_giaochonguoikhac",
      quanlycongviec_danhgia: "quanlycongviec_danhgia",

      //giao dịch trong ngày
      giaodichtrongngay: "giaodichtrongngay",
      giaodichtrongngay_chitietmagiaodich: "giaodichtrongngay_chitietmagiaodich",
      giaodichtrongngay_chitietkhachhang: "giaodichtrongngay_chitietkhachhang",

      // Danh sách khách hàng
      danhsachkhachhang: "danhsachkhachhang",
      danhsachkhachhang_suakhachhang: "danhsachkhachhang_suakhachhang",
      danhsachkhachhang_nhapdanhsachkhachhangtufileexcel: "danhsachkhachhang_nhapdanhsachkhachhangtufileexcel",
      danhsachkhachhang_xuatdanhsachkhachhangrafileexcel: "danhsachkhachhang_xuatdanhsachkhachhangrafileexcel",

      // Thông tin khách vay
      thongtinkhachvay: "thongtinkhachvay",
      thongtinkhachvay_thongtinkhac: "thongtinkhachvay_thongtinkhac",
      thongtinkhachvay_thanhphangiadinh: "thongtinkhachvay_thanhphangiadinh",
      thongtinkhachvay_thongtinchovay: "thongtinkhachvay_thongtinchovay",
      thongtinkhachvay_thongtinkhac_ghichu:
        "thongtinkhachvay_thongtinkhac_ghichu",
      thongtinkhachvay_thanhphangiadinh_thongtinkhac:
        "thongtinkhachvay_thanhphangiadinh_thongtinkhac",
  },
  sConfig: {
    isSoTienThuDauKy: "isSoTienThuDauKy",
  },
};
